/**
 *  This module is copied from the original in the site repo:
 *  https://github.com/finderau/site/blob/master/web/wp-content/themes/finderottrta/include/static/src/js/global/lazy-load-imgs/module.js
 */

export function init(): void {
  const dataQueuedAttributeName = 'data-queued';
  const isFirefoxBrowser = navigator.userAgent.indexOf('Firefox') !== -1;
  const unqueuedElementSelector = ['picture', 'img[data-src]', 'iframe[data-src]']
    // make the each selector to exclude already queued element
    .map((selector) => `${selector}:not([${dataQueuedAttributeName}])`)
    .join(', ');
  const unLoadedElements: NodeListOf<HTMLImageElement> = document.querySelectorAll(
    unqueuedElementSelector
  );

  // filter out <img> within <picture> tag
  const filteredUnloadedElements: HTMLImageElement[] = [];
  for (let i = 0; i < unLoadedElements.length; i++) {
    // mark element as already queued
    unLoadedElements[i].setAttribute(dataQueuedAttributeName, 'true');

    if (unLoadedElements[i].tagName === 'IMG') {
      if (isFirefoxBrowser) {
        // fix for Firefox browser that do not load images with 'display: block' style
        unLoadedElements[i].dataset.firefoxDisplay =
          '' + unLoadedElements[i].style.getPropertyValue('display');
        unLoadedElements[i].style.setProperty('display', 'inline-block');
      }

      if (unLoadedElements[i].parentElement.tagName === 'PICTURE') {
        continue;
      }
    }

    filteredUnloadedElements.push(unLoadedElements[i]);
  }

  const backgroundElements: NodeListOf<HTMLImageElement> = document.querySelectorAll(
    '[data-background-image-url]'
  );

  const hasNoElementsToBeLazyLoaded =
    !filteredUnloadedElements.length && !backgroundElements.length;
  if (hasNoElementsToBeLazyLoaded) {
    return;
  }

  import(
    './lazy-load'
    /* webpackChunkName: "lazy-load-imgs" */
  ).then((module) => {
    module.lazyLoadImages([...filteredUnloadedElements]);
    module.lazyLoadBackgroundImages([...backgroundElements]);
  });

  const requestIdleCallback =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.requestIdleCallback || ((cb: () => void) => window.setTimeout(cb, 300));
  const idleInitModule = () => requestIdleCallback(() => init);

  document.addEventListener('lazy-load-dynamically', idleInitModule, {
    passive: false,
  });
}
